/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL3(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/72ab1d98b65785804fb4fb755ac21e78.jpeg').default
        })`
      }}
      className={`s-ou-l3 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.content, styles.content_layout)}>
        <div className={css(styles.content_item)}>
          <div className={css(styles.component, styles.component_layout)}>
            <HeaderBlack
              icon={
                require('assets/d322d14b233070bbff024a1a56d1eb66.png').default
              }
              image={
                require('assets/c6b10e4947e78c4196251481415c35c3.png').default
              }
            />
          </div>
        </div>
        <div className={css(styles.content_item1)}>
          <div
            style={{
              '--src': `url(${
                require('assets/6f6228516d4c239768953b1a9166326a.png').default
              })`
            }}
            className={css(styles.cover_group, styles.cover_group_layout)}
          >
            <div
              style={{
                '--src': `url(${
                  require('assets/8ce6acdd035b415b33f5b3786c5cd3d7.png').default
                })`
              }}
              className={css(styles.image, styles.image_layout)}
            />
          </div>
        </div>
        <h4 className={css(styles.highlights, styles.highlights_layout)}>
          {'你/妳的靈魂是'}
        </h4>
        <h1 className={css(styles.big_title, styles.big_title_layout)}>
          {'天真無邪的自由小孩'}
        </h1>
        <div className={css(styles.content_item2)}>
          <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
            {
              '初心看似很簡單，卻常常在人生旅途中被遺忘，而你的五感靈魂就是少數保有的新生之犢。金黃色的陽光、彩紅與麥穗，肆無忌憚的在之中穿梭，向環境散播光明與純淨。'
            }
          </h5>
        </div>
        <div className={css(styles.content_item3)}>
          <div
            onClick={() => window.open('/soul', '_self')}
            className={`${css(
              styles.group1,
              styles.group1_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights2, styles.highlights2_layout)}>
              {'五感靈魂樣貌'}
            </h5>
          </div>
        </div>
        <div className={css(styles.content_item4)}>
          <div
            style={{
              '--src': `url(${
                require('assets/1b7f2098fdc315a0b5f2f13148aaa594.png').default
              })`
            }}
            className={css(styles.image1, styles.image1_layout)}
          />
        </div>
        <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
          {'專屬於你的風味想像'}
        </h4>
        <div className={css(styles.content_item5)}>
          <div
            className={css(styles.paragraph_body, styles.paragraph_body_layout)}
          >
            {
              '比百花齊放、水果豐碩的春天更夢幻，一切都是那麼美好，就像是為天使而打造的伊甸園。森林系的自由與輕快，讓快樂變得更純淨，也像是無所事事的午後時光，暖陽輕灑，療育每個人的心。'
            }
          </div>
        </div>
        <h4 className={css(styles.highlights4, styles.highlights4_layout)}>
          {'推薦給你：果樹下的茶・果香有機紅烏龍'}
        </h4>
        <div className={css(styles.content_item6)}>
          <div
            className={css(
              styles.paragraph_body,
              styles.paragraph_body_layout1
            )}
          >
            {
              '如果今天要跟好姊妹約一場下午茶，向你推薦這一款茶。它可以讓彼此快樂暢聊，帶來輕快與放鬆的療癒氛圍，繽紛的花果之地，來者不拒的向每個人開放。'
            }
          </div>
        </div>
        <div className={css(styles.content_item7)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex_item)}>
              <div
                className={css(styles.cover_group1, styles.cover_group1_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout
                  )}
                >
                  {'風味標籤'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item1)}>
              <div
                className={css(
                  styles.small_paragraph_body,
                  styles.small_paragraph_body_layout
                )}
              >
                {'熱帶果物、柑橘果皮、香草軟糖、鳳梨、低含水蜂蜜、牛奶'}
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item8)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex_item)}>
              <div
                className={css(styles.cover_group2, styles.cover_group2_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout1
                  )}
                >
                  {'茶體'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item2)}>
              <div className={css(styles.flex1, styles.flex1_layout)}>
                <div
                  className={css(
                    styles.small_text_body1,
                    styles.small_text_body1_layout
                  )}
                >
                  {'輕盈'}
                </div>
                <div className={css(styles.flex_spacer1)} />
                <div className={css(styles.flex_item3)}>
                  <div className={css(styles.flex2, styles.flex2_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/a7edca698349b80c0c7fe8cba2f76aac.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout1)}
                    />
                    <div className={css(styles.flex_spacer2)} />
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/a03b803116d5c69366011cc7a84de4f0.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout2)}
                    />
                    <div className={css(styles.flex_item4)}>
                      <div className={css(styles.group2, styles.group2_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/be5aa3a84a709c0ed3a0ddc62ac63e3d.svg')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout3)}
                        />
                      </div>
                    </div>
                    <div className={css(styles.flex_item5)}>
                      <div className={css(styles.group3, styles.group3_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/2be574a8953cd7fe16fa799f2540de75.svg')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout4)}
                        />
                      </div>
                    </div>
                    <div className={css(styles.flex_item6)}>
                      <div className={css(styles.group4, styles.group4_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/be75652db97f6007e736029d7d5707e0.svg')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout5)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item9)}>
          <div className={css(styles.flex, styles.flex_layout)}>
            <div className={css(styles.flex_item)}>
              <div
                className={css(styles.cover_group3, styles.cover_group3_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout2
                  )}
                >
                  {'泡法'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item7)}>
              <div className={css(styles.flex3, styles.flex3_layout)}>
                <div className={css(styles.flex_item8)}>
                  <div className={css(styles.flex4, styles.flex4_layout)}>
                    <div className={css(styles.flex_item9)}>
                      <div className={css(styles.flex, styles.flex_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/8256fb8e4c4e8d1cbccf18b12b20b940.png')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout6)}
                        />
                        <div className={css(styles.flex_spacer3)} />
                        <div
                          className={css(
                            styles.small_text_body2_box,
                            styles.small_text_body2_box_layout
                          )}
                        >
                          <div className={css(styles.small_text_body2)}>
                            <span
                              className={css(styles.small_text_body2_span0)}
                            >
                              {'200ml'}
                            </span>
                            <span
                              className={css(styles.small_text_body2_span1)}
                            >
                              {' 熱泡'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body3_box,
                        styles.small_text_body3_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body3)}>
                        <span className={css(styles.small_text_body3_span0)}>
                          {'茶葉 '}
                        </span>
                        <span className={css(styles.small_text_body3_span1)}>
                          {'3g'}
                        </span>
                        <span className={css(styles.small_text_body3_span2)}>
                          {' / 茶包'}
                        </span>
                        <span className={css(styles.small_text_body3_span3)}>
                          {'1'}
                        </span>
                        <span className={css(styles.small_text_body3_span4)}>
                          {'個'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body4_box,
                        styles.small_text_body4_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body4)}>
                        <span className={css(styles.small_text_body4_span0)}>
                          {'水溫：'}
                        </span>
                        <span className={css(styles.small_text_body4_span1)}>
                          {'95-98°C'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body5_box,
                        styles.small_text_body5_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body5)}>
                        <span className={css(styles.small_text_body5_span0)}>
                          {'時間：'}
                        </span>
                        <span className={css(styles.small_text_body5_span1)}>
                          {'2'}
                        </span>
                        <span className={css(styles.small_text_body5_span2)}>
                          {'分鐘'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body6_box,
                        styles.small_text_body6_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body6)}>
                        <span className={css(styles.small_text_body6_span0)}>
                          {'回沖：'}
                        </span>
                        <span className={css(styles.small_text_body6_span1)}>
                          {'3'}
                        </span>
                        <span className={css(styles.small_text_body6_span2)}>
                          {'次'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={css(styles.flex_spacer4)} />
                <div className={css(styles.flex_item10)}>
                  <div className={css(styles.flex5, styles.flex5_layout)}>
                    <div className={css(styles.flex_item11)}>
                      <div className={css(styles.flex, styles.flex_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/cad9bcf9ad1371a1a2b9462ed3feb802.png')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout7)}
                        />
                        <div className={css(styles.flex_spacer5)} />
                        <div
                          className={css(
                            styles.small_text_body7_box,
                            styles.small_text_body7_box_layout
                          )}
                        >
                          <div className={css(styles.small_text_body7)}>
                            <span
                              className={css(styles.small_text_body7_span0)}
                            >
                              {'300ml'}
                            </span>
                            <span
                              className={css(styles.small_text_body7_span1)}
                            >
                              {' 熱泡'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body8_box,
                        styles.small_text_body8_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body8)}>
                        <span className={css(styles.small_text_body8_span0)}>
                          {'茶葉 '}
                        </span>
                        <span className={css(styles.small_text_body8_span1)}>
                          {'3g'}
                        </span>
                        <span className={css(styles.small_text_body8_span2)}>
                          {' / 茶包'}
                        </span>
                        <span className={css(styles.small_text_body8_span3)}>
                          {'1'}
                        </span>
                        <span className={css(styles.small_text_body8_span4)}>
                          {'個'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body9_box,
                        styles.small_text_body9_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body9)}>
                        <span className={css(styles.small_text_body9_span0)}>
                          {'水溫：'}
                        </span>
                        <span className={css(styles.small_text_body9_span1)}>
                          {'95-98°C'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body10_box,
                        styles.small_text_body10_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body10)}>
                        <span className={css(styles.small_text_body10_span0)}>
                          {'時間：'}
                        </span>
                        <span className={css(styles.small_text_body10_span1)}>
                          {'3'}
                        </span>
                        <span className={css(styles.small_text_body10_span2)}>
                          {'分鐘'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body11_box,
                        styles.small_text_body11_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body11)}>
                        <span className={css(styles.small_text_body11_span0)}>
                          {'回沖'}
                        </span>
                        <span className={css(styles.small_text_body11_span1)}>
                          {'：'}
                        </span>
                        <span className={css(styles.small_text_body11_span2)}>
                          {'2'}
                        </span>
                        <span className={css(styles.small_text_body11_span3)}>
                          {'次'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.content_item10)}>
          <div
            onClick={() =>
              window.open(
                'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=7'
              )
            }
            className={`${css(
              styles.group5,
              styles.group5_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights5, styles.highlights5_layout)}>
              {'了解更多'}
            </h5>
          </div>
        </div>
        <div className={css(styles.content_item11)}>
          <div className={css(styles.cover_group4, styles.cover_group4_layout)}>
            <div
              onClick={() => window.open('/', '_self')}
              className={`${css(
                styles.group6,
                styles.group6_layout
              )} cursor-pointer to-home`}
            >
              <div
                className={css(styles.background, styles.background_layout)}
              />
              <h5
                className={css(styles.highlights6, styles.highlights6_layout)}
              >
                {'重新探索'}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL3.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'relative',
    flexGrow: 1
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  content_layout: {
    position: 'relative',
    width: 346,
    minWidth: 346,
    margin: '51px auto 55px'
  },
  content_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 32px',
    minHeight: 0
  },
  component: {},
  component_layout: {
    flexGrow: 1,
    margin: '3px 3px 0px 0px'
  },
  content_item1: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 295px',
    minHeight: 0
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 257,
    flexGrow: 1,
    margin: '38px 0px 0px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 87,
    width: 68,
    minWidth: 68,
    margin: '102px 0px 68px 100px'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69
  },
  highlights_layout: {
    flex: '0 0 auto',
    margin: '15px 0px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '0 0 auto',
    margin: '8px 0px 0px'
  },
  content_item2: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 134px',
    minHeight: 0
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '22px 3px 0px 0px'
  },
  content_item3: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 54px',
    minHeight: 0
  },
  group1: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group1_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '10px 3px 0px 0px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  },
  content_item4: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 302px',
    minHeight: 0
  },
  image1: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image1_layout: {
    height: 257,
    flexGrow: 1,
    margin: '45px 0px 0px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '0 0 auto',
    margin: '21px 0px 0px'
  },
  content_item5: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 95px',
    minHeight: 0
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '7px 3px 0px 0px'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flex: '0 0 auto',
    margin: '45px 0px 0px'
  },
  content_item6: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 81px',
    minHeight: 0
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 3px 0px 0px'
  },
  content_item7: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 52px',
    minHeight: 0
  },
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group1: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '12px 0px 20px'
  },
  small_text_body: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    flexGrow: 1,
    margin: '0px 5px'
  },
  flex_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 279px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    flexGrow: 1,
    margin: '12px 3px 0px 0px'
  },
  content_item8: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 31px',
    minHeight: 0
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 1px'
  },
  small_text_body_layout1: {
    width: 25,
    minWidth: 25,
    margin: '0px auto'
  },
  flex_item2: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 279px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  small_text_body1: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    margin: '0px 0px 1px'
  },
  flex_spacer1: {
    flex: '0 0 auto',
    minWidth: 9
  },
  flex_item3: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 246px'
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '3px 177px 0px 0px'
  },
  image_layout1: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  flex_spacer2: {
    flex: '0 0 auto',
    minWidth: 1
  },
  image_layout2: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  flex_item4: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group2: {
    display: 'flex',
    opacity: 0.2
  },
  group2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout3: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item5: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group3: {
    display: 'flex',
    opacity: 0.2
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout4: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item6: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group4: {
    display: 'flex',
    opacity: 0.2
  },
  group4_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout5: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  content_item9: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 113px',
    minHeight: 0
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group3_layout: {
    position: 'relative',
    height: 'min-content',
    flexGrow: 1,
    margin: '13px 0px 0px'
  },
  small_text_body_layout2: {
    width: 25,
    minWidth: 25,
    margin: '0px auto'
  },
  flex_item7: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 279px'
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '13px 0px 0px'
  },
  flex_item8: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 94px'
  },
  flex4: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item9: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 20px',
    minHeight: 0
  },
  image_layout6: {
    flex: '0 1 18px',
    height: 11,
    width: 18,
    minWidth: 18,
    margin: '5px 0px 4px'
  },
  flex_spacer3: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body2: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body2_box: {},
  small_text_body2_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body2_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body2_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body3_box: {},
  small_text_body3_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body6_box: {},
  small_text_body6_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body6_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex_spacer4: {
    flex: '0 0 auto',
    minWidth: 30
  },
  flex_item10: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 155px'
  },
  flex5: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex5_layout: {
    position: 'relative',
    width: 94,
    minWidth: 94
  },
  flex_item11: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 20px',
    minHeight: 0
  },
  image_layout7: {
    flex: '0 1 18px',
    height: 13,
    width: 18,
    minWidth: 18,
    margin: '4px 0px 3px'
  },
  flex_spacer5: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body7: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body7_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body8_box: {},
  small_text_body8_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body8_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body9_box: {},
  small_text_body9_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body9_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body10_box: {},
  small_text_body10_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body10_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body11_box: {},
  small_text_body11_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body11_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span2: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span3: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  content_item10: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 56px',
    minHeight: 0
  },
  group5: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group5_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 0px 0px'
  },
  highlights5: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights5_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  },
  content_item11: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 60px',
    minHeight: 0
  },
  cover_group4: {
    display: 'flex'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 0px 0px'
  },
  group6: {
    display: 'flex'
  },
  group6_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights6: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights6_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  }
});
